<template>
  <div class="member-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>会员管理</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="showAddDialog">添加会员</el-button>
      </div>

      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="会员类型">
          <el-select v-model="searchForm.type" placeholder="请选择会员类型" clearable>
            <el-option label="课时包" value="package"></el-option>
            <el-option label="包月包" value="monthly"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="学员姓名">
          <el-input v-model="searchForm.xueyuanName" placeholder="请输入学员姓名" clearable></el-input>
        </el-form-item>
        
        <el-form-item label="手机号">
          <el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        
        <el-form-item label="课程">
          <el-select v-model="searchForm.courseId" placeholder="请选择课程" clearable>
            <el-option
              v-for="course in courseOptions"
              :key="course._id"
              :label="course.name"
              :value="course._id">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 会员列表 -->
      <el-table :data="filteredMembers.slice((currentPage - 1) * pageSize, currentPage * pageSize)" style="width: 100%">
        <el-table-column prop="xueyuanName" label="学员姓名"></el-table-column>
        <el-table-column prop="studentName" label="所属微信号" ></el-table-column>
        <el-table-column prop="phone" label="手机号" ></el-table-column>
        <el-table-column prop="courseName" label="课程" ></el-table-column>
        <el-table-column prop="type" label="类型" >
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 'package' ? 'success' : 'primary'">
              {{ scope.row.type === 'package' ? '课时包' : '包月包' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="value" label="总课程">
          <template slot-scope="scope">
            {{ scope.row.type === 'package' ? `${scope.row.totalLessons}课时` : `${scope.row.totalDays || 0}天` }}
          </template>
        </el-table-column>
        <el-table-column prop="value" label="剩余">
          <template slot-scope="scope">
            {{ scope.row.type === 'package' ? `${scope.row.packageCount}课时` : `${scope.row.remainingDays || 0}天` }}
          </template>
        </el-table-column>

        <el-table-column prop="course.price" label="价格">
          <template slot-scope="scope">
            ￥{{ scope.row.course.price }}
          </template>
        </el-table-column>
         <el-table-column prop="createdAt" label="创建时间" ></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    
    <!-- 添加/编辑会员对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :width="dialogWidth">
      <el-form :model="memberForm" :rules="rules" ref="memberForm" label-width="100px">
        <el-form-item label="会员类型" prop="type">
          <el-radio-group v-model="memberForm.type" @change="handleTypeChange">
            <el-radio label="package">课时包</el-radio>
            <el-radio label="monthly">包月包</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="学员姓名" prop="xueyuanName">
          <el-input v-model="memberForm.xueyuanName" placeholder="请输入学员姓名"></el-input>
        </el-form-item>
        
        <el-form-item label="微信" prop="studentId">
          <el-select 
            v-model="memberForm.studentId" 
            placeholder="请选择微信" 
            style="width: 100%"
            @change="handleStudentChange"
            filterable>
            <el-option
              v-for="student in studentOptions"
              :key="student._id"
              :label="student.nickName"
              :value="student._id">
              <span style="float: left">{{ student.nickName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ student.phone }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="memberForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        
        <el-form-item label="课程" prop="courseId">
          <el-select v-model="memberForm.courseId" placeholder="请选择课程" style="width: 100%">
            <el-option
              v-for="course in courseOptions"
              :key="course._id"
              :label="course.name"
              :value="course._id">
            </el-option>
          </el-select>
        </el-form-item>
        
        <!-- 课时包字段 -->
        <el-form-item v-if="memberForm.type === 'package'" label="课时数" prop="packageCount">
          <el-input-number v-model="memberForm.packageCount" :min="1" :max="1000" label="请输入课时数" :disabled="isEditMode"></el-input-number>
        </el-form-item>
        
        <!-- 包月包字段 -->
        <el-form-item v-if="memberForm.type === 'monthly'" label="时间范围" prop="dateRange">
          <el-date-picker
            v-model="memberForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :disabled="isEditMode"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>



        <!-- <el-form-item v-if="memberForm.type === 'package'" label="增加课时" prop="addLessons">
          <el-input-number v-model="memberForm.addLessons" :min="0" :max="1000" label="请输入增加的课时数"></el-input-number>
        </el-form-item>

        <el-form-item v-if="memberForm.type === 'monthly'" label="增加天数" prop="addDays">
          <el-input-number v-model="memberForm.addDays" :min="0" :max="365" label="请输入增加的天数"></el-input-number>
        </el-form-item> -->
        <template v-if="isEditMode">
      <el-form-item v-if="memberForm.type === 'package'" label="增加课时" prop="addLessons">
        <el-input-number 
          v-model="memberForm.addLessons" 
          :min="0" 
          :max="1000" 
          label="请输入增加的课时数">
        </el-input-number>
      </el-form-item>
      
      <el-form-item v-if="memberForm.type === 'monthly'" label="增加天数" prop="addDays">
        <el-input-number 
          v-model="memberForm.addDays" 
          :min="0" 
          :max="365" 
          label="请输入增加的天数">
        </el-input-number>
      </el-form-item>
    </template>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>


      <!-- 分页组件 -->
      <div class="pagination-container" style="text-align: right;margin-top: 10px;margin-right: 10px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="memberList.length">
        </el-pagination>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    
    return {
      isEditMode: false,
      memberList: [], // 初始化为空数组，从API获取数据
  studentOptions: [],
  courseOptions: [],
  dialogVisible: false,
  dialogTitle: '添加会员',
  currentIndex: -1, // 当前编辑的索引
  currentPage: 1,
  pageSize: 10,
  searchForm: {
        type: '',
        xueyuanName: '',
        phone: '',
        courseId: ''
      },
  memberForm: {
    _id: null,      // 添加_id字段
    type: 'package',
    studentId: '',
    phone: '',
    courseId: '',
    xueyuanName: '',
    packageCount: 10,
    dateRange: [],
    addLessons: 0,
    addDays: 0
  },
  rules: {
    type: [{ required: true, message: '请选择会员类型', trigger: 'change' }],
    studentId: [{ required: true, message: '请选择微信', trigger: 'change' }],
    phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
    courseId: [{ required: true, message: '请选择课程', trigger: 'change' }],
    packageCount: [{ required: true, message: '请输入课时数', trigger: 'blur' }],
    dateRange: [{ required: true, message: '请选择时间范围', trigger: 'change' }],
    xueyuanName: [{ required: true, message: '请输入学员姓名', trigger: 'blur' }]
  },
   // 响应式相关数据
   screenWidth: window.innerWidth
    }
  },
  created() {
    this.userInfo()
    this.courseInfo()
    this.getMemberList();  
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
     // 判断是否为桌面设备
     isDesktop() {
      return this.screenWidth >= 1024;
    },
    // 对话框宽度
    dialogWidth() {
      return this.screenWidth < 768 ? '100%' : '35%';
    },
    // 计算分页后的会员数据
    filteredMembers() {
      return this.memberList.filter(member => {
        // 会员类型筛选
        if (this.searchForm.type && member.type !== this.searchForm.type) {
          return false;
        }
        
        // 学员姓名筛选
        if (this.searchForm.xueyuanName && 
            !member.xueyuanName.includes(this.searchForm.xueyuanName)) {
          return false;
        }
        
        // 手机号筛选
        if (this.searchForm.phone && 
            !member.phone.includes(this.searchForm.phone)) {
          return false;
        }
        
        // 课程筛选
        if (this.searchForm.courseId && 
            member.courseId !== this.searchForm.courseId) {
          return false;
        }
        
        return true;
      });
    }
  },
  methods: {
     // 处理窗口大小变化
     handleResize() {
      this.screenWidth = window.innerWidth;
    },
    // 获取会员列表
    getMemberList() {
  this.$http.get('/api/members')
    .then(response => {
      console.log('会员列表',response.data.data)
      this.memberList = response.data.data;
    })
    .catch(error => {
      console.error('获取会员列表失败:', error);
      this.$message.error('获取会员列表失败');
    });
},
    //用户列表
    userInfo(){
      this.$http.get('/api/auth/users')
              .then(response => {
                console.log('用户列表',response.data.data)
                this.studentOptions = response.data.data
              }).catch(error => {
                  console.error('获取用户失败:', error);
                  this.$message.error('获取用户失败');
              });
    },
    //课程列表
    courseInfo(){
      this.$http.get('/api/courses')
              .then(response => {
                console.log('课程列表',response.data.data.list)
                 this.courseOptions = response.data.data.list
              }).catch(error => {
                  console.error('获取课程失败:', error);
                  this.$message.error('获取课程失败');
              });
    },
    // 显示添加对话框
    showAddDialog() {
      this.dialogTitle = '添加会员';
      this.currentIndex = -1;
      this.resetForm();
      this.dialogVisible = true;
      this.isEditMode = false;
    },
    
    // 显示编辑对话框
    handleEdit(index, row) {
this.dialogTitle = '编辑会员';
this.currentIndex = index;
this.isEditMode = true;

// 填充表单数据
this.memberForm = {
  _id: row._id,  // 添加这行
  type: row.type,
  studentId: row.studentId,
  phone: row.phone,
  courseId: row.courseId,
  xueyuanName: row.xueyuanName,
  packageCount: row.packageCount || 0,
  dateRange: row.startDate && row.endDate ? [new Date(row.startDate), new Date(row.endDate)] : [],
  addLessons: 0,
  addDays: 0
};

this.dialogVisible = true;
},
    
    // 删除会员
    handleDelete(index, row) {
this.$confirm('确定要删除该会员吗?', '提示', {
  confirmButtonText: '确定',
  cancelButtonText: '取消',
  type: 'warning'
}).then(() => {
  this.$http.delete(`/api/members/${row._id}`)
    .then(response => {
      this.$message.success(response.data.message);
      this.getMemberList(); // 刷新列表
    })
    .catch(error => {
      this.$message.error(error.response?.data?.message || '删除失败');
    });
}).catch(() => {
  this.$message.info('已取消删除');
});
},
// 提交表单
submitForm() {
  this.$refs.memberForm.validate((valid) => {
    if (valid) {
      const isEditMode = this.currentIndex !== -1;
      const memberId = isEditMode ? this.memberForm._id : null;

      // 准备请求数据
      const requestData = {
        type: this.memberForm.type,
        studentId: this.memberForm.studentId,
        xueyuanName: this.memberForm.xueyuanName,
        phone: this.memberForm.phone,
        courseId: this.memberForm.courseId,
        addLessons: this.memberForm.addLessons || 0,
        addDays: this.memberForm.addDays || 0
      };

      // 只有包月类型才需要处理日期
      if (this.memberForm.type === 'monthly') {
        // 如果有修改日期范围，使用新范围
        if (this.memberForm.dateRange && this.memberForm.dateRange.length === 2) {
          requestData.dateRange = [
            this.formatDateForAPI(this.memberForm.dateRange[0]),
            this.formatDateForAPI(this.memberForm.dateRange[1])
          ];
        }
        // 如果没有修改日期范围但增加了天数，后端会处理延长日期
      } else {
        // 课时包逻辑
        requestData.packageCount = this.memberForm.packageCount;
        requestData.totalLessons = this.memberForm.packageCount;
      }

      const request = isEditMode
        ? this.$http.put(`/api/members/${memberId}`, requestData)
        : this.$http.post('/api/members', requestData);

      request.then(response => {
        this.$message.success(response.data.message);
        this.dialogVisible = false;
        this.getMemberList(); // 刷新列表
      }).catch(error => {
        this.$message.error(error.response?.data?.message || '操作失败');
      });
    }
  });
},
 // 搜索处理
 handleSearch() {
      this.currentPage = 1; // 搜索时重置到第一页
    },
      // 重置搜索
      resetSearch() {
      this.searchForm = {
        type: '',
        xueyuanName: '',
        phone: '',
        courseId: ''
      };
      this.currentPage = 1;
    },
    

// 辅助方法：格式化日期为API需要的格式
formatDateForAPI(date) {
  if (!date) return null;
  const d = new Date(date);
  return d.toISOString().split('T')[0];
},
    
    // 重置表单
    resetForm() {
      this.memberForm = {
        id: 0,
        type: 'package',
        studentId: '',
        phone: '',
        courseId: '',
        packageCount: 10,
        dateRange: [],
        xueyuanName: ''
      };
      
      if (this.$refs.memberForm) {
        this.$refs.memberForm.resetFields();
      }
    },
    
    // 会员类型变化
    handleTypeChange() {
      // 切换类型时清空相关字段
      if (this.memberForm.type === 'package') {
        this.memberForm.dateRange = [];
      } else {
        this.memberForm.packageCount = 0;
      }
    },
    
    // 微信选择变化
    handleStudentChange(studentId) {
      const student = this.studentOptions.find(s => s._id === studentId);
      if (student) {
        this.memberForm.phone = student.phone;
      }
    },
     // 分页大小变化
     handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 每页条数改变时重置到第一页
    },
    
    // 当前页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();
      
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      
      return [year, month, day].join('-');
    }
  }
}
</script>

<style scoped>
.member-container {
  /* padding: 20px; */
}
.box-card {
  margin-bottom: 20px;
}
</style>